///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rx_item.maintenance = abcsetup.rx_item.maintenance || {};
abcsetup.rx_item.maintenance.edit = abcsetup.rx_item.maintenance.edit || {};




///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rx_item.maintenance.edit.removeButtons = [];




///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rx_item.maintenance.edit = {
    init: function() {
        abcsetup.setTitle('Maintain Rx Item');
        abcsetup.rx_item.maintenance.edit.removeButtons = ['maintenance_approve_screenshot', 'sap_pricing_letter', 'ahp_pricing_letter', 'mwi_pricing_letter'];

        // Set the global item var
        abcsetup.item = JSON.parse($('form.rx-item #item_object').html());
        abcsetup.form_manager.form = $('form.rx-item');
        abcsetup.form_manager.setFormItems();

        // Init any field restrictions/values
        this._initFields();

        // Init the GTIN Grid
        this._initGTIN();

        // Init the attachment buttons
        this._initAttachments();

        // Delete attachment button clicked
        $(document).on('click', '.delete-attachment', function(event) {
            event.preventDefault();
            var _this = $(this);

            abcsetup.alerts.confirm('Delete Attachment', 'Are you sure you want to delete this attachment?', function (resp) {
                if (resp) {
                    _this.parent().fadeOut('slow', function() {
                        $(this).remove();

                        // Auto save the item form
                        // abcsetup.rx_item.maintenance.edit._autoSave();
                        $('button#'+_this.attr("id")).addClass('required btn-danger').show();
                    });
                }
            });
        });
        $(document).on('click', 'button[name="cancel_maintenance"]', function(event){
            event.preventDefault();
            var _this = $(this);
            abcsetup.alerts.confirm('Cancel Maintenance', 'Are you sure you would like to cancel maintenance?', function (resp) {
                if (resp) {
                    abcsetup.form_manager.form.append("<input type='hidden' name='form_action' value='cancel_maintenance'>");
                    abcsetup.form_manager.form.submit();
                }
            });
            // <button type="submit" name="form_action" value="cancel_maintenance" class="btn btn-warning  button cancel_maintenance mr-3" formnovalidate>Cancel Maintenance</button>
        });
    },

    /**
     * _jquery.fieldLib
     *      Fields have been init - this is the callback
     */
    fieldsInit: function() {
        // Note: all rx item form related JS is handled in the global /forms/_rx_item.js form namespace
        abcsetup.rx_item.form.init(true);
    },

    /**
     * Init any field restrictions/values
     */
    _initFields: function() {
        require('./_common_rules');
    },

    /**
     * Init the attachment buttons
     */
    _initAttachments: function() {
        $(abcsetup.rx_item.maintenance.edit.removeButtons).each(function() {
            $('button#' + this).remove();
            $('input[data-idx="' + this + '"]').remove();
        });

        /*
        // Manually apply showIf rules to buttons and their input fields
        $('button#sds_waiver, input[data-idx="sds_waiver"]').attr('showIf', 'sds_waiver=N');
        abcsetup.fieldLib.bindElement($('button#sds_waiver, input[data-idx="sds_waiver"]'), 'showIf');

        $('button#msds_sheet, input[data-idx="msds_sheet"]').attr('showIf', 'sds_waiver=Y');
        abcsetup.fieldLib.bindElement($('button#msds_sheet, input[data-idx="msds_sheet"]'), 'showIf');

        $('button#fda_waiver, input[data-idx="fda_waiver"]').attr('showIf', 'fda_exempt=Y');
        abcsetup.fieldLib.bindElement($('button#fda_waiver, input[data-idx="fda_waiver"]'), 'showIf');

        $('button#pr_registration_doc, input[data-idx="pr_registration_doc"]').attr('showIf', 'pr_registration=Y');
        abcsetup.fieldLib.bindElement($('button#pr_registration_doc, input[data-idx="pr_registration_doc"]'), 'showIf');

        $('button#short_dated_offer_letter, input[data-idx="short_dated_offer_letter"]').attr('showIf', 'item_setup_reason=Short Dated');
        abcsetup.fieldLib.bindElement($('button#short_dated_offer_letter, input[data-idx="short_dated_offer_letter"]'), 'showIf');
        */

        $("button#other_upload_button").removeClass("required btn-danger").hide();
        $("button#short_dated_offer_letter").removeClass("required btn-danger").hide();
        $("button#fda_waiver").removeClass("required btn-danger").hide();
        $("button#spec_sheet").removeClass("required btn-danger").hide();
        $("button#sds_waiver").removeClass("required btn-danger").hide();
        $("button#msds_sheet").removeClass("required btn-danger").hide();
        $("button#case_label").removeClass("required btn-danger").hide();
        //$("button#pr_registration_doc").removeClass("required btn-danger").hide();
        $("button#front_panel_product_image").removeClass("required btn-danger").hide();
        $("button#flat_product_bar_code_image").removeClass("required btn-danger").hide();
        $("button#hda_form").removeClass("required btn-danger").hide();
        $("button#prescribing_information_attachment").removeClass("required btn-danger").hide();

        // Monitor button class changes from _common_rules
        setInterval(function() {
            $('.item_attachments button').each(function() {
                var id = $(this).attr('id');
                if ($(this).hasClass('required')) {
                    $(this).addClass('btn-danger');
                    var field = $('input.attachment_file[data-idx="' + id + '"]').filter(function() { return $(this).val() == ""; });

                    // Add a new required field for an additional attachment of the current type
                    if (field.length == 0) {
                        field = $('<input type="text" name="file_attachments[]" class="attachment_file" fieldValidate="attachmentFile" data-type="' + $(this).html() + '" data-idx="' + id + '" autocomplete="off">');
                        $(this).after(field);
                    }

                    field.show().attr('required', true);

                } else {
                    var fields = $('input.attachment_file[data-idx="' + id + '"]');
                    fields.hide().attr('required', false);
                }
            });
        }, 500);
    },


    /**
     * Init the GTIN Grid
     */
    _initGTIN: function() {
        require('../_gtin_grid');

        //$('#gtin_grid_items table').show();
        if (abcsetup.item.gtin_items && abcsetup.item.gtin_items.length) {
            $(abcsetup.item.gtin_items).each(function() {
                var row = $('#gtin_grid_items table').find('input:checkbox[value="' + this.level_id + '"]').closest('tr');
                row.find('input.form-check-input').prop('checked', true);
                row.find('input.level_name').val(this.level_name);
                row.find('.gtin_saleable_unit').val(this.saleable_unit);
                row.find('.gtin_rfid_tag').val(this.rfid_tag);
                row.find('.gtin_qty').val(this.qty);
                row.find('.gtin_grid_gtin_14').val(this.gtin_14);
                row.find('.gtin_grid_hibcc').val(this.hibcc);
                row.find('.mgf').val(this.mgf);
            });
        }
    },

    // /**
    //  * Auto save the item form
    //  */
    // _autoSave: function() {
    //     $('form.rx-item').append('<input type="hidden" class="tmp-action" name="form_action" value="update">');
    //     axios.post('/rx_item/maintenance/' + abcsetup.item.id + '?auto=t', $('form.rx-item').serialize()).then(response => {
    //         $('form.rx-item').find('.tmp-action').remove();
    //     });
    // },
}
